import styled from 'styled-components';

export const StyledLoginPage = styled.div`
    background-color: ${(props: any) => props.backgroundColor};
    min-height: 550px;
    width: ${(props: any) => props.width};
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    font-family: ${(props: any) => props.fontFamily};
    & > * {
        margin-top: 20px;
    }
    a {
        color: white;
    }
    h2 {
        max-width: 90%;
        color: ${(props: any) => props.textColor};
        font-size: ${(props: any) => props.textSize}px;
        font-weight: ${(props: any) => props.textWeight};
        text-align: center;
        font-family: ${(props: any) => props.fontFamily};
    }
    .usernameContainer {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    .backButton {
        color: white;
        font-size: 20px;
        background-color: transparent;
        border: 0;
        position: absolute;
        bottom: -100px;
        cursor: pointer;
    }
` as any;

export const StyledImageContainer = styled.div`
    display: flex;
    justify-content: center;
    position: relative;
    width: 100%;
    height: 160px;
    .logo {
        object-fit: contain;
        height: 100%;
        max-height: 150px;
    }
` as any;

export const StyledLoginConatainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 500px;
    max-width: 100%;
    img.loginButton {
        max-width: 90%;
        margin-bottom: 12px;
        cursor: pointer;
        &:active {
            transform: scale(95%);
        }
    }
    span {
        text-align: center;
        max-width: 80%;
        font-size: 12px;

        & > span {
            text-decoration: underline;
            cursor: pointer;
        }
    }
` as any;

export const StyledLoginInput = styled.input`
    padding-left: 12px;
    width: 450px;
    max-width: 90%;
    height: 50px;
    margin-bottom: 12px;
    font-size: 16px;
    border-radius: 8px;
    color: white;
    border: 1px solid white;
    background-color: transparent;

    &::placeholder {
        color: white;
    }

    @media (min-width: 500px) {
        height: 60px;
    }
`;
